import gql from 'graphql-tag';

export default gql`
  query fetchOverlays {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        configurations {
          merchandiseOverlayDisplay
          __typename
        }
      }
      __typename
    }
  }
`;
